import classNames from 'classnames';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from './IwLink.module.css';
import { REQUEST_CHANGE_ROUTER } from './IwRouter.actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    navigateTo: (location: Partial<Location>) =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location
        })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

type Props = {
    className?: string;
    activeClassName?: string;
    to: string;
    'data-testid'?: string;
    children: React.ReactNode;
} & PropsFromRedux;

const IwLink = ({
    className,
    navigateTo,
    to,
    'data-testid': dataTestId,
    children
}: Props) => (
    <button
        className={classNames(styles.IwLink, className)}
        onClick={() => navigateTo({ pathname: to })}
        data-testid={dataTestId}
    >
        {children}
    </button>
);

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(IwLink);
